import { get } from "http";
import api from "../../config/apiConfig";

const getUnlistedInventory = async (data: any) => {
  const accessToken = localStorage.getItem("accessToken");
  const response = await api.post("rm/unlisted/getAll", data, {
    headers: {
      Authorization: accessToken,
    },
  });
  return response.data;
};

const getUnlistedInvestors = async (data: any) => {
  const accessToken = localStorage.getItem("accessToken");
  const response = await api.post("rm/unlisted/investor/getAll", data, {
    headers: {
      Authorization: accessToken,
    },
  });
  return response.data;
};

const getUnlistedDPMaping = async () => {
  const accessToken = localStorage.getItem("accessToken");
  const response = await api.post("admin/unlisted/investor/getUnlistedTextDpid",{}, {
    headers: {
      Authorization: accessToken,
    },
  });
  return response.data;
};

const addUnlistedInvestor = async (data: any) => {
  const accessToken = localStorage.getItem("accessToken");
  const response = await api.post("rm/unlisted/investor", data, {
    headers: {
      Authorization: accessToken,
    },
  });
  return response.data;
};

const addUnlistedOrder = async (data: any) => {
  const accessToken = localStorage.getItem("accessToken");
  const response = await api.post("rm/unlisted/createOrder", data, {
    headers: {
      Authorization: accessToken,
    },
  });
  return response.data;
};

const getUnlistedOrders = async (data: any) => {
  const accessToken = localStorage.getItem("accessToken");
  const response = await api.post("rm/unlisted/getOrders", data, {
    headers: {
      Authorization: accessToken,
    },
  });
  return response.data;
};

const executeUnlistedOrder = async (data: any) => {
  const accessToken = localStorage.getItem("accessToken");
  const response = await api.post("rm/unlisted/order/execute", data, {
    headers: {
      Authorization: accessToken,
    },
  });
  return response.data;
};

const uploadUnlistedInvestorDocs = async (data: FormData) => {
  const accessToken = localStorage.getItem("accessToken");
  const response = await api.post("rm/unlisted/upload", data, {
    headers: {
      Authorization: accessToken,
    },
  });
  return response.data;
};

const getUnlistedHoldings = async (data: any) => {
  const accessToken = localStorage.getItem("accessToken");
  const response = await api.post("rm/unlisted/holdings", data, {
    headers: {
      Authorization: accessToken,
    },
  });
  return response.data;
};

const getInvoice = async (data: any) => {
  const accessToken = localStorage.getItem("accessToken");
  const response = await api.post("rm/unlisted/getInvoice", data, {
    headers: {
      Authorization: accessToken,
    },
    timeout: 30000,
  });
  return response.data;
}

const addBankDetails = async (data: any) => {
  const accessToken = localStorage.getItem("accessToken");
  const response = await api.post("rm/unlisted/addBankAcc", data, {
    headers: {
      Authorization: accessToken,
    },
  });
  return response.data;
}

const getInvestorBanks = async (data: any) => {
  const accessToken = localStorage.getItem("accessToken");
  const response = await api.post("rm/unlisted/getAllBank", data, {
    headers: {
      Authorization: accessToken,
    },
  });
  return response.data;
}

const editOrder = async (data: any) => {
  const accessToken = localStorage.getItem("accessToken");
  const response = await api.post("rm/unlisted/editOrder", data, {
    headers: {
      Authorization: accessToken,
    },
  });
  return response.data;
}

const getReport = async (data: any) => {
  const accessToken = localStorage.getItem("accessToken");
  const response = await api.post("rm/unlisted/report", data, {
    headers: {
      Authorization: accessToken,
    },
  });
  return response.data;
}

const getDpById = async (data: any) => {
  const accessToken = localStorage.getItem("accessToken");
  const response = await api.post("rm/unlisted/getDpById", data, {
    headers: {
      Authorization: accessToken,
    },
  });
  return response.data;
}

const rmService = {
  getUnlistedInventory,
  getUnlistedInvestors,
  addUnlistedInvestor,
  addUnlistedOrder,
  getUnlistedOrders,
  executeUnlistedOrder,
  getUnlistedHoldings,
  uploadUnlistedInvestorDocs,
  getInvoice,
  addBankDetails,
  getInvestorBanks,
  editOrder,
  getReport,
  getDpById,
  getUnlistedDPMaping,
};
export default rmService;
